// extracted by mini-css-extract-plugin
module.exports = {"container":"Layout_container__2uPav","content":"Layout_content__sG1AN","withBG":"Layout_withBG__2pdJY","header":"Layout_header__24Bwz"};